/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import {db} from '@/firebaseConfig';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue')
              },
              {
                path: '/search/name',
                name: 'nameSearch',
                component: () => import('./views/searches/NameSearch'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Búsquedas', url: '#'},
                    {title: 'Nombre', active: true},
                  ],
                  pageTitle: 'Búsqueda por nombre'
                }
              },
              {
                path: '/search/plate',
                name: 'plateSearch',
                component: () => import('./views/searches/PlateSearch'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Búsquedas', url: '#'},
                    {title: 'Placa', active: true},
                  ],
                  pageTitle: 'Búsqueda por placa'
                }
              },
              {
                path: '/search/chassis',
                name: 'chassisSearch',
                component: () => import('./views/searches/ChassisSearch'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Búsquedas', url: '#'},
                    {title: 'Chasis', active: true},
                  ],
                  pageTitle: 'Búsqueda por chasis'
                }
              },
              {
                path: '/search/motor',
                name: 'motorSearch',
                component: () => import('./views/searches/MotorSearch'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Búsquedas', url: '#'},
                    {title: 'Motor', active: true},
                  ],
                  pageTitle: 'Búsqueda por motor'
                }
              },
              {
                path: '/statistics/stealsVehicleType',
                name: 'stealsVehicleType',
                component: () => import('./views/statistics/StealsVehicleType'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Estadísticas', url: '#'},
                    {title: 'Robos por tipo de vehículo', active: true},
                  ],
                  pageTitle: 'Robos por tipo de vehículo'
                }
              },
              {
                path: '/statistics/top10zones',
                name: 'top10zones',
                component: () => import('./views/statistics/Top10Zones'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Estadísticas', url: '#'},
                    {title: 'Top 10 colisiones', active: true},
                  ],
                  pageTitle: 'Top 10 de colisiones por zona'
                }
              },
              {
                path: '/statistics/periodCompare',
                name: 'periodCompare',
                component: () => import('./views/statistics/PeriodCompare'),
                meta: {
                  breadcrumb: [
                    {title: 'Inicio', url: '/'},
                    {title: 'Estadísticas', url: '#'},
                    {title: 'Comparación 2 períodos', active: true},
                  ],
                  pageTitle: 'Comparación 2 períodos'
                }
              }
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
});

//
// Autenticación interna
//
router.beforeEach((to, from, next) => {
  if (to.name == 'login') {
    next();
  } else {
    if (store.state.AppActiveUser.token) {
      db.collection('sessions').doc(store.state.AppActiveUser.token).get().then(snapshot => {
        if (snapshot.exists) {
          next();
        } else {
          next({name: 'login'});
        }
      });
    } else {
      if (to.name == 'login') {
        next();
      } else {
        next({name: 'login'});
      }
    }
  }
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
